// @flow

export type State = {
  [string]: any,
};

export class StateManager {
  activeIndex: number = -1;
  states: Array<State> = [];

  addState(state: State) {
    this.states = this.states.slice(0, this.activeIndex + 1);
    this.states.push(state);
    this.activeIndex = this.states.length - 1;
  }

  canUndo() {
    return this.activeIndex > 0;
  }

  canRedo() {
    const statesNum = this.states.length;
    return statesNum > 1 && this.activeIndex < this.states.length - 1;
  }

  reverseState() {
    this.activeIndex--;
    return this.states[this.activeIndex];
  }

  forwardState() {
    this.activeIndex++;
    return this.states[this.activeIndex];
  }
}
